namespace GeniuzPOS.ReportMasterData {
    export interface Report_1309Row {
        ID?: string;
        ShopId?: string;
        ShopName?: string;
        DayOfWeek?: string;
        DocDate?: string;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
        AllItemCharge?: number;
        VatOfCharge?: number;
        FullName?: string;
    }

    export namespace Report_1309Row {
        export const idProperty = 'ID';
        export const nameProperty = 'ID';
        export const localTextPrefix = 'ReportMasterData.Report_1309';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';

        export declare const enum Fields {
            ID = "ID",
            ShopId = "ShopId",
            ShopName = "ShopName",
            DayOfWeek = "DayOfWeek",
            DocDate = "DocDate",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales",
            AllItemCharge = "AllItemCharge",
            VatOfCharge = "VatOfCharge",
            FullName = "FullName"
        }
    }
}
